// campaignThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/axios'; // use project axios instance


// Create new campaign
export const createCampaign = createAsyncThunk(
    'campaign/createCampaign',
    async (campaignData, { rejectWithValue }) => {
        try {
            const response = await api.post('/api/campaign', campaignData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Fetch all campaigns
export const fetchCampaigns = createAsyncThunk(
    'campaign/fetchCampaigns',
    async (projectId, { rejectWithValue }) => {
        try {
            // adjust path if your backend exposes /api/campaign or /campaign depending on lib/axios baseURL
            const response = await api.get('/api/campaign', { params: { projectId } });
            return response.data;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('fetchCampaigns error:', error?.response?.status, error?.response?.data || error?.message);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


// Update existing campaign
export const updateCampaign = createAsyncThunk(
    'campaign/updateCampaign',
    async ({ id, updatedCampaign }, { rejectWithValue }) => {

        try {
            const response = await api.put(`/api/editCampaign/${id}`, updatedCampaign);
            return response.data;
        } catch (error) {
            console.error("Update Campaign Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


// Delete campaign
export const deleteCampaign = createAsyncThunk(
    'campaign/deleteCampaign',
    async ({ id, projectId }, { rejectWithValue }) => {
        try {
            await api.delete(`/api/campaign/${id}`, { params: { projectId } });
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
